// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Z\\+B-re7Q{display:flex;flex-direction:column;gap:6rem;padding:4rem 0}@media(max-width:1324.98px){.Z\\+B-re7Q{padding:4rem var(--spacing-lg)}}@media(max-width:667.98px){.Z\\+B-re7Q{padding:4rem var(--spacing-md)}}.ITtUSMtt{align-items:center;display:flex;justify-content:space-between}@media(max-width:667.98px){.ITtUSMtt{align-items:flex-start;flex-direction:column}}.H2TYyCRb{display:flex;flex-direction:column;gap:2.5rem;max-width:45rem}@media(max-width:667.98px){.H2TYyCRb{gap:1.5rem}}.fGoCF2zf{color:var(--color-primary);font-size:max(2.5rem,min(5vw,4.38rem));line-height:1.1;text-transform:uppercase}@media(max-width:947.98px){.fGoCF2zf br{display:none}}.\\+H9Y4958{font-size:max(1.13rem,min(2vw,1.5rem))}.\\+H9Y4958 a{color:var(--color-primary)}.K1gmVuIT{width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xs": "667.98",
	"sm": "947.98",
	"md": "1023.98",
	"lg": "1324.98",
	"container": "Z+B-re7Q",
	"header": "ITtUSMtt",
	"info": "H2TYyCRb",
	"title": "fGoCF2zf",
	"description": "+H9Y4958",
	"image": "K1gmVuIT"
};
module.exports = ___CSS_LOADER_EXPORT___;
